export const environment = {
  production: true,
  useEmulators: false,
  socialSignInWithPopup: false,
  firebase: {
    projectId: 'atchurch-300d5',
    appId: '1:77497503277:web:9d296a1cc0c1b2fbc232a4',
    databaseURL: 'https://atchurch-300d5.firebaseio.com',
    storageBucket: 'atchurch-300d5.appspot.com',
    locationId: 'us-central',
    apiKey: 'AIzaSyCGiKzK0tGMP9juPA7xq3B6zU7ZI4t2H4Q',
    // Same site as the app, so redirect sign-in works where third-party storage is
    // blocked. Amplify proxies /__/auth/* and /__/firebase/* to atchurch-300d5.firebaseapp.com.
    authDomain: 'web.atchurch.app',
    messagingSenderId: '77497503277',
    measurementId: 'G-9820CB0ZRY',
  },
  vapidKey:
    'BCvGA26cCa2tf2zZBhEoV5kE0gCDiyDTsgqk7PBgfIdpEnR-dfo2GTSxLoIVJ_T-VnVtx9bFaPSclxeOH1iqNhI',
  domain: 'web.atchurch.app',
  FIRESTORE_USERS_COLLECTION: 'users',
  FIRESTORE_GROUPS_COLLECTION: 'groups',
  FIRESTORE_GROUPS_METADATA_COLLECTION: 'groups_metadata',
  FIRESTORE_Q_BANK_COLLECTION: 'question_bank',
  FIRESTORE_QUIZZES_COLLECTION: 'quizzes',
  FIRESTORE_QUIZ_ATTEMPTS_COLLECTION: 'attempts',
  FIRESTORE_USER_ANSWERS_COLLECTION: 'user_responses',
  FIRESTORE_QUIZ_REPORTS_COLLECTION: 'quiz_reports',
  FIRESTORE_FCM_TOKENS_COLLECTION: 'fcm_tokens',
  RECAPTCHA_SITE_KEY: '6LdwfXMsAAAAAPb97zruUoWF61JDz4nXFxllK7lA',
  STRIPE_PUBLISHABLE_KEY:
    'pk_test_51PpUV6KnmvBguOL9E5fHmhR0KfGM0iuOgrf4bHO5ZJYHTCP0VGAgXNFPnvkqdTfp00XXv0KsdUHQX0Si10GI5yoc00VVyocXb5',
  STRIPE_SECRET_KEY:
    'sk_test_51PpUV6KnmvBguOL9sY2Y2f1Y6Yk1b0j1Yk3JH6z1b0j1Yk3JH6z1b0j1Yk3JH6z1b0j1Yk3JH6z1b0j1Yk3JH600D3j4K5j',
  STRIPE_SCHOOL_SEATS_PRICE_ID: 'prod_TQqEowVFMUF4i0',
  STRIPE_STORAGE_5GB_PRICE_ID: 'prod_TSlagXNUZCOoEe',
  STRIPE_STORAGE_10GB_PRICE_ID: 'prod_TSlbsp6nY2dHfS',
  STRIPE_SCHOOL_FREE_SEATS: 25,
  STRIPE_AI_TOKENS_1K_PRICE_ID: 'price_1ShAI_Tokens_1k',

  FUNCTION_STRIPE_CREATE_INTENT: 'payment_createSetupIntent',
  FUNCTION_STRIPE_CREATE_SUBSCRIPTION: 'payment_createSubscription',
  FUNCTION_STRIPE_GET_SUBSCRIPTION_BY_SETUP_INTENT:
    'payment_getSubscriptionFromSetupIntent',

  ONE_SIGNAL_APPID: '7c99755b-4f3a-4b13-a155-0acf1967b3c1',
  APPSTORE_ID: '1582338471',
  ANDROID_PACKAGE_NAME: 'app.atchurch.atchurch',
  APP_URL_SCHEME: 'app.atchurch.atchurch',
  SMARTLOOK_PROD: 'af12341069d85f690d2ad5791516fb49a3479139',
  AWS_API_KEY: 'zBkIsiv62M16cQFoyny001ByamN7RRWz9yrBKY3Q',
  MAPS_API_KEY: 'AIzaSyDp-H81BPmLVStUnSTFr0Lh2lHZuN9dcyY',
  AWS_ALBUMS_API_KEY: 'thhj2rrTnM6oWwFdSl5yP2Y96O9TKgbj5TG1ligj',
  AWS_SEARCH_API_KEY: 'nBr2H5VrfO5PwvUQDD4DFbyNVWtFD8c17DePpq78',
  PEXELS_API_KEY: 'K4Yqyzb9tPUMOpV6Z9XU32OjzVoxn7SuTPL2ULAAtHG0ea1fdf0RwHtD',
  PEXELS_SEARCH: 'https://api.pexels.com/v1/search',
  ATLASSIAN_CREATE_ISSUE: 'https://atchurch.atlassian.net/rest/api/3/issue',
  ATLASSIAN_PROJECT_KEY: 'ATC',
  ATLASSIAN_USER: 'support@atchurch.app',
  ATLASSIAN_API_TOKEN:
    'ATATT3xFfGF0PjralCZFiG8V0A8cupTKo2kHnSqB1iPrLuacpSJMKCcsFXnhADyzBJ-DiTL-2UgRYceqICNKRqJ3pbjIMyNMSXnIAQYm-j1rVJaHHKVkFdvbrJncOTW6Tyn8b5SArHmBuMjHnYd1C682oRE4gqnvY1vKaVllWkoAp51GcLjpUw4=8D9FEF60',
  AWS_CHANNEL_IMAGES_CLOUDFRONT: 'dhrrigpg7b8al.cloudfront.net',
  AWS_VIDEO_IMAGES_CLOUDFRONT: 'dhr2o50esy2yj.cloudfront.net',
  AWS_PODCAST_IMAGES_CLOUDFRONT: 'd1setz35thjgm7.cloudfront.net',
  AWS_PODCAST_AUDIO_CLOUDFRONT: 'd1i10wvk4g5glj.cloudfront.net',
  AWS_GROUPS_CLOUDFRONT: 'd1udolvham6mb7.cloudfront.net',
  AWS_USERS_CLOUDFRONT: 'd3hy226wn8xo4e.cloudfront.net',
  AWS_CHANNEL_IMAGE_SIGNEDURL:
    'https://65rtms83sd.execute-api.eu-west-1.amazonaws.com/prod/channelsignedurl',
  AWS_CHANNEL_EXISTS:
    'https://65rtms83sd.execute-api.eu-west-1.amazonaws.com/prod/exists',
  AWS_CHANNEL_FETCH:
    'https://65rtms83sd.execute-api.eu-west-1.amazonaws.com/prod/getmychannels',
  AWS_CHANNEL_CREATE:
    'https://65rtms83sd.execute-api.eu-west-1.amazonaws.com/prod/createchannel',
  AWS_CHANNEL_UPDATE:
    'https://65rtms83sd.execute-api.eu-west-1.amazonaws.com/prod/updatechannel',
  AWS_CHANNEL_SUBSCRIBE:
    'https://65rtms83sd.execute-api.eu-west-1.amazonaws.com/prod/subscribe',
  AWS_CHANNEL_UNSUBSCRIBE:
    'https://65rtms83sd.execute-api.eu-west-1.amazonaws.com/prod/unsubscribe',
  AWS_CHANNEL_MYSUBSCRIPTIONS:
    'https://65rtms83sd.execute-api.eu-west-1.amazonaws.com/prod/getmysubscriptions',
  AWS_CHANNEL_SUBSCRIBERS:
    'https://65rtms83sd.execute-api.eu-west-1.amazonaws.com/prod/getsubscribercount',
  AWS_CHANNEL_SUBSCRIPTION_STATUS:
    'https://65rtms83sd.execute-api.eu-west-1.amazonaws.com/prod/getsubscriptionstatus',
  AWS_PODCAST_IMAGE_SIGNEDURL:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/getimagesignedurl',
  AWS_PODCAST_AUDIO_SIGNEDURL:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/getaudiosignedurl',
  AWS_PODCAST_FETCH:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/getmypodcasts',
  AWS_PODCAST_SERIES_FETCH:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/getmyseries',
  AWS_PODCAST_CREATE:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/createpodcast',
  AWS_PODCAST_UPDATE:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/updatepodcast',
  AWS_PODCAST_UPDATE_STATUS:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/updatestatus',
  AWS_PODCAST_DELETE:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/deletepodcast',
  AWS_PODCAST_TRANSACTION_DELETE:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/droptransaction',
  AWS_PODCAST_TRANSACTION_HIDE:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/hideforcontinuelistening',
  AWS_PODCAST_GET_BY_ID:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/getpodcasts/byid',
  AWS_PODCAST_GET_ANALYTICS:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/getPodcastAnalytics',
  AWS_PODCAST_GET_RATING:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/getpodcastrating',
  AWS_PODCAST_GET_USERRATING:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/getuserrating',
  AWS_PODCAST_UPDATE_USERRATING:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/putrating',
  AWS_PODCAST_PUSH_ANALYTICS:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/pushanalyticsevent',
  AWS_PODCAST_CONTINUE_LISTENING:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/getpodcasts/continuelistening',
  AWS_PODCAST_TRENDING_NOW:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/getpodcasts/trendingnow',
  AWS_PODCAST_TOP_PICKS:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/getpodcasts/toppicksforyou',
  AWS_PODCAST_MORE_LIKE:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/getpodcasts/morelike',
  AWS_SEARCH_PODCAST_BY_FILTERS:
    'https://szyrahedgi.execute-api.eu-west-1.amazonaws.com/prod/search/podcastsbyfilters',
  AWS_SEARCH_PODCAST_BY_DATE:
    'https://qa9jcka20d.execute-api.eu-west-1.amazonaws.com/prod/podcastsbydate',
  AWS_SEARCH_GROUPS_BY_LOCATION:
    'https://qa9jcka20d.execute-api.eu-west-1.amazonaws.com/prod/groupsbylocation',
  AWS_SEARCH_EVENTS_NEARME:
    'https://vaudn5wa8h.execute-api.eu-west-1.amazonaws.com/prod/search/nearme',
  AWS_SEARCH_EVENTS_BY_FILTERS:
    'https://vaudn5wa8h.execute-api.eu-west-1.amazonaws.com/prod/search/byfilters',
  AWS_VIDEO_FETCH:
    'https://jxix4cr1r8.execute-api.eu-west-1.amazonaws.com/prod/getMyVideos',
  AWS_VIDEO_FETCH_BY_ID:
    'https://jxix4cr1r8.execute-api.eu-west-1.amazonaws.com/prod/getVideos/byId',
  AWS_VIDEO_SIGNEDURL:
    'https://jxix4cr1r8.execute-api.eu-west-1.amazonaws.com/prod/getVideoSignedUrl',
  AWS_VIDEO_THUMBNAIL_SIGNEDURL:
    'https://jxix4cr1r8.execute-api.eu-west-1.amazonaws.com/prod/getImageSignedUrl',
  AWS_VIDEO_CREATE:
    'https://jxix4cr1r8.execute-api.eu-west-1.amazonaws.com/prod/createVideo',
  AWS_VIDEO_UPDATE:
    'https://jxix4cr1r8.execute-api.eu-west-1.amazonaws.com/prod/updateVideo',
  AWS_VIDEO_DELETE:
    'https://jxix4cr1r8.execute-api.eu-west-1.amazonaws.com/prod/deleteVideo',
  AWS_VIDEO_UPLOAD_INITIALIZE:
    'https://jxix4cr1r8.execute-api.eu-west-1.amazonaws.com/prod/upload/initialize',
  AWS_VIDEO_UPLOAD_LIST_PARTS:
    'https://jxix4cr1r8.execute-api.eu-west-1.amazonaws.com/prod/upload/listparts',
  AWS_VIDEO_UPLOAD_PART:
    'https://jxix4cr1r8.execute-api.eu-west-1.amazonaws.com/prod/upload/getPreSignedUrl',
  AWS_VIDEO_UPLOAD_COMPLETE:
    'https://jxix4cr1r8.execute-api.eu-west-1.amazonaws.com/prod/upload/finalize',
  AWS_VIDEO_UPLOAD_ABORT:
    'https://jxix4cr1r8.execute-api.eu-west-1.amazonaws.com/prod/upload/abort',
  AWS_ARTICLE_FETCH:
    'https://adyif8ou62.execute-api.eu-west-1.amazonaws.com/prod/getMyArticles',
  AWS_ARTICLE_SIGNEDURL:
    'https://adyif8ou62.execute-api.eu-west-1.amazonaws.com/prod/getUploadUrl',
  AWS_ARTICLE_CREATE:
    'https://adyif8ou62.execute-api.eu-west-1.amazonaws.com/prod/createArticle',
  AWS_ARTICLE_UPDATE:
    'https://adyif8ou62.execute-api.eu-west-1.amazonaws.com/prod/updateArticle',
  AWS_ARTICLE_DELETE:
    'https://adyif8ou62.execute-api.eu-west-1.amazonaws.com/prod/deleteArticle',
  AWS_SEARCH_GROUPS_BY_ID:
    'https://qa9jcka20d.execute-api.eu-west-1.amazonaws.com/prod/groups/byGroupId',
  AWS_SCHOOL_LESSON_SIGNEDURL:
    'https://b89o681fg6.execute-api.eu-west-1.amazonaws.com/prod/lessons/requestSignedUrl',
  AWS_SCHOOL_ASSIGNMENTS_SIGNEDURL:
    'https://b89o681fg6.execute-api.eu-west-1.amazonaws.com/prod/assignments/requestSignedUrl',
  AWS_SCHOOL_ASSIGNMENTS_STUDENTWORK_SIGNEDURL:
    'https://b89o681fg6.execute-api.eu-west-1.amazonaws.com/prod/studentwork/requestSignedUrl',
  AWS_SCHOOL_AWARDS_SIGNEDURL:
    'https://b89o681fg6.execute-api.eu-west-1.amazonaws.com/prod/awards/getUploadUrl',
  AWS_SCHOOL_NOTICE_IMAGE_SIGNEDURL:
    'https://b89o681fg6.execute-api.eu-west-1.amazonaws.com/prod/notice/getImageSignedUrl',
  AWS_SCHOOL_NOTICE_DELETE:
    'https://b89o681fg6.execute-api.eu-west-1.amazonaws.com/prod/notice/deleteS3Notice',
  AWS_SCHOOL_NOTICE_ATTACHMENT_SIGNEDURL:
    'https://b89o681fg6.execute-api.eu-west-1.amazonaws.com/prod/notice/getAttachmentSignedUrl',
  AWS_SCHOOL_NOTICE_DELETE_ATTACHMENT:
    'https://b89o681fg6.execute-api.eu-west-1.amazonaws.com/prod/notice/deleteS3Attachment',
  AWS_SCHOOL_GRADELESSONNOTES_SIGNEDURL:
    'https://b89o681fg6.execute-api.eu-west-1.amazonaws.com/prod/gradeNotes/requestSignedUrl',
  AWS_ALBUMS_FETCH:
    'https://fzpfnbu024.execute-api.eu-west-1.amazonaws.com/prod/albums',
  AWS_ALBUM_CREATE:
    'https://fzpfnbu024.execute-api.eu-west-1.amazonaws.com/prod/create',
  AWS_ALBUM_UPDATE: '',
  AWS_ALBUM_DELETE: '',
  AWS_ALBUM_IMAGE_SIGNEDURL:
    'https://fzpfnbu024.execute-api.eu-west-1.amazonaws.com/prod/getPresignedUrl',
  AWS_ALBUM_IMAGE_DELETE:
    'https://fzpfnbu024.execute-api.eu-west-1.amazonaws.com/prod/deleteImage',
};
